var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBoxRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M20.23 7.24006L12 12.0001L3.77002 7.24006C3.93897 6.94756 4.17994 6.70314 4.47002 6.53006L11 2.76006C11.62 2.41006 12.38 2.41006 13 2.76006L19.53 6.53006C19.82 6.70306 20.061 6.94806 20.23 7.24006Z",
    fill: "#26A7DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12 12V21.5C11.6847 21.4995 11.3736 21.4277 11.09 21.29L4.5 17.48C4.19647 17.3044 3.94435 17.0522 3.76886 16.7486C3.59337 16.445 3.50066 16.1007 3.5 15.75V8.24999C3.50165 7.89571 3.59465 7.54784 3.77 7.23999L12 12Z",
    fill: "#26A7DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8.24999V15.75C20.4993 16.1007 20.4066 16.445 20.2311 16.7486C20.0556 17.0522 19.8035 17.3044 19.5 17.48L12.88 21.3C12.605 21.43 12.304 21.498 12 21.5V12L20.23 7.23999C20.405 7.54799 20.498 7.89599 20.5 8.24999Z",
    fill: "#26A7DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoxRed);
export default __webpack_public_path__ + "static/media/ic_box_red.e36127fc497e2eb13e7545ee41349e52.svg";
export { ForwardRef as ReactComponent };